module.exports = __webpack_public_path__ + "img/latest_art-explore_art.039eb20f.jpg";